// extracted by mini-css-extract-plugin
export default {"app":"App_app__vgtJA","heading":"App_heading__Fhq-j","appContainer":"App_appContainer__yAZLO"};